import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { UserFormValues } from "src/models/User.model";
import UserForm from "../Layouts/UserForm";
import { useAdduserMutation } from "src/services/UserService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddUserFormWrapper = ({ onClose }: Props) => {
  const [addUser] = useAdduserMutation();

  // Form Initial Values
  const initialValues: UserFormValues = {
    name: "",
    email: "",
    password: "",
    mobile: "",
    roleId: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    email: string().email().required("Please enter email"),
    password: string().required("Please enter password"),
    mobile: string()
      .required("Please enter mobile number")
      .matches(/^[0-9]{10}$/, {
        message: "Mobile number should contain exactly 10 digits.",
      }),
    roleId: object().required("Please select role"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UserFormValues,
    { setSubmitting, resetForm }: FormikHelpers<UserFormValues>
  ) => {
      const formatedValues={
      name : values?.name ,
      mobile :values?.mobile,
      email:values?.email,
      password:values?.password,
      roleId:values?.roleId.value
    }
      addUser(formatedValues).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
   
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UserForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddUserFormWrapper;
